// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from "./store";
import baseUrl from "@/fetch/url";


import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
// import locale from 'element-ui/lib/locale/lang/en' // lang i18n
import locale from "element-ui/lib/locale/lang/zh-CN";
import { Message } from "element-ui";
import "@/styles/index.scss"; // global css
import baseConfig from "./utils/config";
import {setQuery } from "@/utils/utils.js";
import { formatTime, formatTimestamp } from "@/utils";
import dayjs from "dayjs";

// import "@/permission"; // permission control

/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */
// set ElementUI lang to EN
Vue.use(ElementUI, { locale });
// 如果想要中文版 element-ui，按如下方式声明
// Vue.use(ElementUI)
Vue.prototype.$message = Message;



Vue.prototype.$config = baseConfig;
Vue.prototype.$imgUrl = baseUrl.imgUrl;
Vue.config.productionTip = false;
window.setQuery = setQuery;

Vue.prototype.$dayjs = dayjs;
// 定义全局过滤器
// 时间过滤
Vue.filter("formatTime", (e) => {
  return formatTime(e);
})
// 时间过滤
Vue.filter("formatTimeNo", (e) => {
  return formatTime(e,"",true);
})

// 时间过滤
Vue.filter("formatTimestamp", (e) => {
  return formatTimestamp(e);
});
/* eslint-disable no-new */
export const vm = new Vue({
         el: "#app",
         router,
         store,
         components: { App },
         template: "<App/>"
       });



// WEBPACK FOOTER //
// ./src/main.js